import { render, staticRenderFns } from "./doctorinfo.vue?vue&type=template&id=1ac614c1"
import script from "./doctorinfo.vue?vue&type=script&lang=js"
export * from "./doctorinfo.vue?vue&type=script&lang=js"
import style0 from "./doctorinfo.vue?vue&type=style&index=0&id=1ac614c1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports